import { cx } from 'cva';
import { type FunctionComponent, useRef } from 'react';
import { type ChannelPreviewUIComponentProps } from 'stream-chat-react';

// Use the following as a reference
// https://github.com/GetStream/stream-chat-react/blob/master/src/components/ChannelPreview/ChannelPreviewMessenger.tsx

export const ChannelPreview: FunctionComponent<
  ChannelPreviewUIComponentProps
> = ({
  active,
  channel,
  displayTitle,
  key,
  onSelect,
  setActiveChannel,
  unread,
  watchers,
}) => {
  const channelPreviewButton = useRef<HTMLButtonElement | null>(null);

  const onSelectChannel = (e: React.MouseEvent<HTMLButtonElement>): void => {
    if (onSelect) {
      onSelect(e);
    } else if (setActiveChannel) {
      setActiveChannel(channel, watchers);
    }
    if (channelPreviewButton.current) {
      channelPreviewButton.current.blur();
    }
  };

  return (
    <div className="str-chat__channel-preview-container" key={key}>
      <button
        aria-selected={active}
        className={cx(
          'str-chat__channel-preview',
          'str-chat__channel-preview-messenger',
          active && 'str-chat__channel-preview-messenger--active',
          unread &&
            unread >= 1 &&
            'str-chat__channel-preview-messenger--unread',
        )}
        onClick={onSelectChannel}
        ref={channelPreviewButton}
        type="button"
      >
        <div className="str-chat__channel-preview-end">
          <div className="str-chat__channel-preview-end-first-row">
            <div className="str-chat__channel-preview-messenger--name">
              <span>{displayTitle}</span>
            </div>
            {!!unread && (
              <div
                className="str-chat__channel-preview-unread-badge"
                data-testid="unread-badge"
              >
                {unread}
              </div>
            )}
          </div>
        </div>
      </button>
    </div>
  );
};
